var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{staticClass:"!py-3 is-dark-green",attrs:{"id":_vm.itemId,"data-test":_vm.testId,"disabled":_vm.disabled,"type":_vm.type},on:{"click":function($event){return _vm.$emit('clicked')}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }